const Cycles = {
  "0": "Year A",
  "1": "Year B",
  "2" : "Year C"
};
export default Cycles;